import { apiClient } from '@/lib/api/api-client'
import type { CurrentUser } from '@/features/auth/types/user'

export const apiGetCurrentUser = () =>
  apiClient<CurrentUser>('/api/v1/users/me')
